import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Pencil, Trash2, X, FileX } from 'lucide-react';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const Events = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const NProgressSpinner = () => (
    <div style={{ padding: "1rem", textAlign: "center" }}>
      <div
        style={{
          boxSizing: "border-box",
          display: "block",
          width: "40px",
          height: "40px",
          border: "4px solid #29d",
          borderRadius: "50%",
          borderTopColor: "transparent",
          animation: "spin 0.6s linear infinite",
          margin: "0 auto 10px"
        }}
      ></div>
      <div>Memuat data, sabar yaa gaes...</div>
    </div>
  );

  const handleExport = (e) => {
    window.location.href = `${process.env.REACT_APP_BASE_URL}export/events`;
  };

  useEffect(() => {
    // Ambil data dari localStorage
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/login"); // Jika tidak ada user, arahkan ke login
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const [data, setData] = useState([]);

  const [pending, setPending] = useState(true);
  const [editEvent, setEditEvent] = useState(null);
  const [addEvent, setAddEvent] = useState(null); // data yang diedit
  const [formData, setFormData] = useState({ name: '', client: '' , status: '' });
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/events`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data);
        setPending(false);
      });
  };

  const filteredData = data.filter((item) =>
  item.name.toLowerCase().includes(searchText.toLowerCase()) ||
  item.client.toLowerCase().includes(searchText.toLowerCase())||
  item.status.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleEdit = (event) => {
    setEditEvent(event);
    setFormData({ name: event.name, client: event.client, status:event.status });
  };

  const handleAdd = (event) => {
    setAddEvent(event);
    setFormData({ name: event.name, client: event.client, status:event.status });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Event ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/events/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Data berhasil dihapus.', 'success');
            fetchData();
          });
      }
    });
  };


  const handleUpdate = (e) => {
    e.preventDefault();
    fetch(`${process.env.REACT_APP_BASE_URL}api/events/${editEvent.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then(() => {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Data berhasil diperbarui!',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        setEditEvent(null);
        fetchData();
      });
  };

  const handleInsert = async (e) => {
  e.preventDefault();

  try {
    // 1. Ambil semua event dulu
    const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/events`);
    const json = await response.json();
    const existingEvents = json.data;

    // 2. Cek apakah nama sudah ada (case-insensitive)
    const isDuplicate = existingEvents.some(
      (event) => event.name.toLowerCase() === formData.name.toLowerCase()
    );

    if (isDuplicate) {
      // 3. Tampilkan error jika duplikat
      Swal.fire({
        icon: 'error',
        title: 'Gagal Menyimpan',
        text: 'Nama event sudah ada. Gunakan nama lain.',
      });
      return;
    }

    // 4. Lanjutkan menyimpan jika tidak duplikat
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/events/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!res.ok) {
      throw new Error('Gagal menyimpan data');
    }

    // 5. Berhasil
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Data berhasil disimpan!',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    setAddEvent(null);
    fetchData(); // refresh data tabel
    } catch (error) {
      console.error('Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Terjadi kesalahan',
        text: error.message || 'Gagal menyimpan data',
      });
    }
  };


  const columns = [
    {
      name: 'Nama',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Klien',
      selector: row => row.client,
      sortable: true,
    },
    {
      name: 'Status',
      cell: (row) => (
        <span
          className={`px-2 py-1 text-xs font-semibold rounded-full ${
            row.status === "1"
              ? 'bg-green-100 text-green-700'
              : 'bg-red-100 text-red-700'
          }`}
        >
          {row.status === "1" ? 'Aktif' : 'Tidak Aktif'}
        </span>
      ),
    },
    {
      name: 'Aksi',
      cell: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-yellow-400 hover:bg-yellow-500 text-white p-1 rounded"
            onClick={() => handleEdit(row)}
          >
            <Pencil size={16} />
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white p-1 rounded"
            onClick={() => handleDelete(row.id)}
          >
            <Trash2 size={16} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    table: {
      style: {
        border: '1px solid #ccc', // border luar tabel
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f3f4f6', // bg abu-abu muda
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
      },
    },
    headCells: {
      style: {
        borderRight: '1px solid #ccc',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #ccc',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #eee',
      },
    },
  };


  return (
    <div className="p-2">
      <div className="flex justify-between mb-4 gap-2">
          <div className="flex justify-between gap-2">
            <button
              className="bg-black hover:bg-black/50 text-white px-4 py-2 rounded"
              onClick={handleAdd}>
              + Tambah
            </button>  
            <button type="button"
              onClick={handleExport} className="flex items-center border border-green-300 bg-green-500 hover:bg-green-700 text-green-700 px-2 py-2 gap-2 rounded shadow text-md text-white ">
              <FileX size={16} /> Export ke Excel
            </button>
          </div>
          <input
            type="text"
            placeholder="Pencarian..."
            className="border border-gray-300 px-2 py-2 rounded w-full md:w-1/4"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          /> 
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        responsive
        progressPending={pending}
        progressComponent={<NProgressSpinner  />}
        highlightOnHover
        striped
        fixedHeader
        customStyles={customStyles}
      />

      {/* Modal Edit */}
      {editEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setEditEvent(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Edit Event</h3>
            <form onSubmit={handleUpdate} className="space-y-4">
              <div>
                <label className="block font-medium">Nama</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Klien</label>
                <input
                  type="text"
                  value={formData.client}
                  onChange={(e) =>
                    setFormData({ ...formData, client: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Status</label>
                <button
                  type="button"
                  onClick={() =>
                    setFormData({ ...formData, status: !formData.status })
                  }
                  className={`w-14 h-7 flex items-center rounded-full p-1 transition-colors duration-300 ${
                    formData.status ? "bg-green-500" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
                      formData.status ? "translate-x-7" : "translate-x-0"
                    }`}
                  />
                </button>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setEditEvent(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70 "
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {addEvent && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg">
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-red-500"
              onClick={() => setAddEvent(null)}
            >
              <X size={20} />
            </button>
            <h3 className="text-lg font-bold mb-4">Tambah Event</h3>
            <form onSubmit={handleInsert} className="space-y-4">
              <div>
                <label className="block font-medium">Nama</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  required
                />
              </div>
              <div>
                <label className="block font-medium">Klien</label>
                <input
                  type="text"
                  value={formData.client}
                  onChange={(e) =>
                    setFormData({ ...formData, client: e.target.value })
                  }
                  className="w-full border border-gray-300 p-2 rounded"
                  
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Status</label>
                <button
                  type="button"
                  onClick={() =>
                    setFormData({ ...formData, status: !formData.status })
                  }
                  className={`w-14 h-7 flex items-center rounded-full p-1 transition-colors duration-300 ${
                    formData.status ? "bg-green-500" : "bg-gray-300"
                  }`}
                >
                  <div
                    className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
                      formData.status ? "translate-x-7" : "translate-x-0"
                    }`}
                  />
                </button>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300 rounded"
                  onClick={() => setAddEvent(null)}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-black/100 text-white rounded hover:bg-black/70"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;
